import SidebarHeader from '@/components/Modals/Sidebar/components/SidebarHeader';
import useDynamicSidebarHeader from '@/components/Modals/Sidebar/hooks/useDynamicSidebarHeader';
import { UpgradePlanTabs } from './tabs';
const UpgradePlanModalHeader = () => {
  // Used for controlling the sidebar header when specific screens are active
  useDynamicSidebarHeader({
    dynamicTabs: [...UpgradePlanTabs]
  });
  return <SidebarHeader data-sentry-element="SidebarHeader" data-sentry-component="UpgradePlanModalHeader" data-sentry-source-file="header.tsx" />;
};
export { UpgradePlanModalHeader };